import { render, staticRenderFns } from "./FormActivityTopicImport.vue?vue&type=template&id=70acf02f&scoped=true"
import script from "./FormActivityTopicImport.vue?vue&type=script&lang=js"
export * from "./FormActivityTopicImport.vue?vue&type=script&lang=js"
import style0 from "./FormActivityTopicImport.vue?vue&type=style&index=0&id=70acf02f&prod&lang=scss&scoped=true"
import style1 from "./FormActivityTopicImport.vue?vue&type=style&index=1&id=70acf02f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70acf02f",
  null
  
)

export default component.exports